import type { FC } from 'react';
import AdvancedProgressBar from '@/components/advancedProgressBar';
import MarkdownContent from '../MarkdownContent';
import { HubSectionTitle } from './SectionTitle';

interface ExpertReviewSectionProps {
  text: string;
  percentage: number;
}

export const ExpertReviewSection: FC<ExpertReviewSectionProps> = ({
  text,
  percentage,
}) => {
  return (
    <div
      className="flex flex-col gap-3 rounded-lg bg-medium-gray p-4"
      id="expert"
    >
      <HubSectionTitle>Expert review</HubSectionTitle>
      <AdvancedProgressBar progress={percentage} type="large" />
      <MarkdownContent>{text ?? ''}</MarkdownContent>
    </div>
  );
};
